<template>
  <a-modal
    :mask="false"
    class="my-import-dowload-dialog"
    :width="1000"
    title="我的导入导出"
    :visible="visible"
    destroyOnClose
    :footer="null"
    @cancel="onCancel"
    @ok="onConfirm"
  >
    <a-tabs v-model="activeKey" tab-position="left" :style="{ height: '513px' }">
      <a-tab-pane key="import">
        <template #tab>
          <span class="title">
            <sass-icon type="hi-daoru" /> 导入记录
          </span>
        </template>
        <record-table v-if="visible" type="import"/>
      </a-tab-pane>
      <a-tab-pane key="dowload">
        <template #tab>
          <span class="title">
            <sass-icon type="hi-daochu" /> 导出记录
          </span>
        </template>
        <record-table v-if="visible" type="dowload"/>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import RecordTable from './recordTable'
export default {
  name: 'MyImportDowload',
  data () {
    return {
      activeKey: 'import',
      importData: {
        count: 0
      },
      dowload: {
        count: 0
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.activeKey = 'dowload'
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('update:visible', false)
    },
    onConfirm () {
      this.$emit('update:visible', false)
    }
  },
  components: {
    RecordTable
  }
}
</script>
<style lang="less">
.my-import-dowload-dialog {
  .ant-modal-body {
    padding: 0px;
    .ant-tabs-left-bar {
      .ant-tabs-tab {
        padding: 8px 20px;
        margin: 16px 0px 0px 0px;
        .title {
          padding: 12px;
          font-size: 14px;
        }
        &.ant-tabs-tab-active {
          .title {
            background: rgba(0, 164, 151, 0.06);
          }
        }
      }
    }
    .ant-tabs-content {
      padding: 20px 20px 0px;
    }
  }
}
</style>
